import React from 'react';
import LandingPageView from './View';
import { LandingPageProps } from './types';

// Context imports
import { SettingsProvider } from './contexts/SettingsContext';
import { ImageRefProvider } from './contexts/ImageRefContext';
import { ThreadProvider } from './contexts/ThreadContext';
import { CropProvider } from './contexts/CropContext';
import { RegionEditProvider } from './contexts/RegionEditContext';
import { MediaProvider } from './contexts/MediaContext';
import { FeedbackProvider } from './contexts/FeedbackContext';
import { VideoProvider } from './contexts/VideoContext';
import { EditorProvider } from './contexts/EditorContext';

const LandingPage: React.FC<LandingPageProps> = ({ db, uid, hasAccessToBulkTreatments, hasAccessToAiChat }) => {
  return (
    <SettingsProvider>
      <ImageRefProvider>
        <ThreadProvider>
          <MediaProvider>
            <CropProvider>
              <RegionEditProvider>
                <FeedbackProvider db={db} uid={uid}>
                  <VideoProvider db={db} uid={uid}>
                    <EditorProvider db={db} uid={uid} hasAccessToBulkTreatments={hasAccessToBulkTreatments}>
                      <LandingPageView uid={uid} hasAccessToBulkTreatments={hasAccessToBulkTreatments} hasAccessToAiChat={hasAccessToAiChat} />
                    </EditorProvider>
                  </VideoProvider>
                </FeedbackProvider>
              </RegionEditProvider>
            </CropProvider>
          </MediaProvider>
        </ThreadProvider>
      </ImageRefProvider>
    </SettingsProvider>
  );
};

export default LandingPage;
